import api from './base'
import { objectToQueryString } from '../utils/object'

export default {
  getAll ({ businessUnitId, filters }) {
    return api().get(`company/business_units/${businessUnitId}/acceptance_forms?${objectToQueryString(filters)}`)
  },
  getById ({ businessUnitId, id, filters }) {
    filters = filters || { includeArticles: true }
    return api().get(`company/business_units/${businessUnitId}/acceptance_forms/${id}?${objectToQueryString(filters)}`)
  },
  save ({ businessUnitId, item }) {
    return api().put(`company/business_units/${businessUnitId}/acceptance_forms`, item)
  },
  delete ({ businessUnitId, id }) {
    return api().delete(`company/business_units/${businessUnitId}/acceptance_forms/${id}`)
  },
  articleMargin ({ businessUnitId, id, params }) {
    return api().get(`company/business_units/${businessUnitId}/acceptance_forms/${id}/margin?${objectToQueryString(params)}`)
  },
  getPDFList ({ businessUnitId, filters }) {
    return api().get(`company/business_units/${businessUnitId}/acceptance_forms/pdf?${objectToQueryString(filters)}`)
  },
  getPDFSamostojen ({ businessUnitId, acceptanceFormId }) {
    return api().get(`company/business_units/${businessUnitId}/acceptance_forms/${acceptanceFormId}/pdf`)
  }
}
